import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Col, DatePicker, Drawer, Input, Row, Space } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseRadioList from '@/components/Elements/BaseRadios';
import ImageSelector from '@/components/ImageSelector';
import { _newLine, isValidDateForm } from '@/utils/helpers';
import { updateSpecificSpinHistories } from '@/redux/actions/rewardSpinActions';

class RewardSpinForm extends Component {
    state = { requireTime: false, isLoading: false, images: [], resetSignal: 0 };

    componentDidUpdate(prevProps) {
        const opened = this.props.visible && !prevProps.visible;
        const changed = this.props.currentItem !== prevProps.currentItem;
        if (opened || changed) {
            const currentItem = this.props.currentItem || {};
            this.setState({
                requireTime: Number(currentItem.status) === 1,
                images: Array.isArray(currentItem.images) ? currentItem.images : []
            });
            if (this.props.visible) {
                this.props.form.setFieldsValue({
                    status: Number(currentItem.status || 0),
                    received_date: currentItem.received_date ? isValidDateForm(currentItem.received_date, false) : null,
                    note: _newLine(currentItem.note || ''),
                    videos: currentItem.videos || ''
                });
            }
        }
    }

    submit = event => {
        event.preventDefault();
        this.props.form.validateFields((error, values) => {
            if (error || !this.props.currentItem) return;
            const payload = {
                ...values,
                images: this.state.images,
                received_date: values.received_date ? values.received_date.format('YYYY-MM-DD HH:mm') : null
            };

            this.setState({ isLoading: true });
            this.props.updateSpecificSpinHistories(this.props.currentItem.id, payload)
                .then(() => {
                    this.props.onCancel();
                    this.props.reloadData();
                    this.props.form.resetFields();
                    this.setState(state => ({ images: [], resetSignal: state.resetSignal + 1 }));
                })
                .finally(() => this.setState({ isLoading: false }));
        });
    };

    close = () => {
        this.props.form.resetFields();
        this.setState(state => ({ isLoading: false, images: [], resetSignal: state.resetSignal + 1 }));
        this.props.onCancel();
    };

    changeStatus = status => {
        const requireTime = Number(status) === 1;
        this.setState({ requireTime });
        if (!requireTime) this.props.form.setFieldsValue({ received_date: null });
    };

    handleImageChange = fileList => {
        const images = (fileList || []).map(file => ({
            manual_id: file.manual_id ?? file.uid ?? file.id,
            src: file.originalImage ?? file.src ?? file.url
        })).filter(image => image.src);
        this.setState({ images });
    };

    render() {
        const { visible, currentItem } = this.props;
        const { getFieldDecorator } = this.props.form;
        const { requireTime, isLoading, images, resetSignal } = this.state;

        return (
            <Drawer
                visible={visible}
                title="Cập nhật kết quả quay thưởng"
                onClose={this.close}
                maskClosable={false}
                width={isMobile ? '100%' : '40%'}
                footer={(
                    <div style={{ textAlign: 'right' }}>
                        <Space>
                            <Button onClick={this.close}>Hủy</Button>
                            <Button loading={isLoading} type="primary" onClick={this.submit}>Cập nhật</Button>
                        </Space>
                    </div>
                )}
            >
                {visible && (
                    <Form layout="vertical" onSubmit={this.submit}>
                        <Row gutter={16}>
                            <Col xs={24}>
                                <Form.Item label="Trạng thái">
                                    {getFieldDecorator('status', {
                                        initialValue: Number(currentItem?.status || 0),
                                        rules: [{ required: true, message: 'Vui lòng chọn trạng thái.' }]
                                    })(
                                        <BaseRadioList
                                            options={[{ label: 'Đã nhận thưởng', value: 1 }, { label: 'Chưa nhận thưởng', value: 0 }]}
                                            onChange={this.changeStatus}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            {requireTime && (
                                <Col xs={24}>
                                    <Form.Item label="Thời gian nhận">
                                        {getFieldDecorator('received_date', {
                                            initialValue: currentItem?.received_date ? isValidDateForm(currentItem.received_date, false) : null,
                                            rules: [{ required: true, message: 'Vui lòng nhập thời gian nhận thưởng.' }]
                                        })(<DatePicker style={{ width: '100%' }} showTime={{ format: 'HH:mm' }} format="DD/MM/YYYY HH:mm" />)}
                                    </Form.Item>
                                </Col>
                            )}
                            <Col xs={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', { initialValue: _newLine(currentItem?.note || '') })(<Input.TextArea rows={3} />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item label="Ảnh minh chứng">
                                    <ImageSelector
                                        multiple
                                        maxCount={10}
                                        defaultFileList={images}
                                        resetSignal={resetSignal}
                                        onChangeData={this.handleImageChange}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item label="Video nhúng YouTube/OneDrive">
                                    {getFieldDecorator('videos', { initialValue: currentItem?.videos || '' })(
                                        <Input.TextArea rows={6} placeholder="Dán mã iframe HTTPS từ YouTube hoặc OneDrive" />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Drawer>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    updateSpecificSpinHistories: (id, data) => dispatch(updateSpecificSpinHistories(id, data))
});

export default connect(null, mapDispatchToProps)(Form.create({ name: 'RewardSpinForm' })(RewardSpinForm));
